import { createContext } from "react";
const UserInputContext = createContext();
export default UserInputContext;
